import { date1IsBeforeDate2, validateDateObject } from '@/core/validators';

export function subOrdersInitialValidationState(subOrders) {
	let errorsSubOrders = { isInvalid: null };

	subOrders.forEach( subOrder => {

		errorsSubOrders[subOrder.id] = {
			isInvalid: null,
			etd: null,
			eta: null,
			atd: null,
			ata: null
		};
	});

	return errorsSubOrders;
}

export function validateSubOrders(subOrders) {
	let errorsSubOrders = { isInvalid: null };
	let hasInvalidSubOrder = false;

	subOrders.forEach( subOrder => {
		let errorsSubOrder = { };

		let subOrderIsInvalid = false;

		errorsSubOrder.etd = subOrder.etd && validateDateObject( subOrder.etd );
		errorsSubOrder.eta = subOrder.eta && validateDateObject( subOrder.eta );
		errorsSubOrder.atd = subOrder.atd && validateDateObject( subOrder.atd );
		errorsSubOrder.ata = subOrder.ata && validateDateObject( subOrder.ata );

		if (errorsSubOrder.etd || errorsSubOrder.eta || errorsSubOrder.atd || errorsSubOrder.ata) {
			subOrderIsInvalid = true;
			hasInvalidSubOrder = true;
		}

		if (subOrder.etd && subOrder.eta && !errorsSubOrder.etd && !errorsSubOrder.eta) {

			let isInvalid;

			if (
				subOrder.etd.date && subOrder.eta.date
				&& ( subOrder.etd.date.slice(0, 8) === subOrder.eta.date.slice(0, 8) )
				&& subOrder.etd.hasTime && !subOrder.eta.hasTime
			) {
				isInvalid = false;

			} else {
				isInvalid = date1IsBeforeDate2(subOrder.etd, subOrder.eta);
			}

			if (isInvalid) {
				subOrderIsInvalid = true;
				hasInvalidSubOrder = true;
			}
			errorsSubOrder.etd = isInvalid;
			errorsSubOrder.eta = isInvalid;
		}

		if (subOrder.atd && subOrder.ata && !errorsSubOrder.atd && !errorsSubOrder.ata) {

			let isInvalid;

			if (
				subOrder.atd.date && subOrder.ata.date
				&& ( subOrder.atd.date.slice(0, 8) === subOrder.ata.date.slice(0, 8) )
				&& subOrder.atd.hasTime && !subOrder.ata.hasTime
			) {
				isInvalid = false;

			} else {
				isInvalid = date1IsBeforeDate2(subOrder.atd, subOrder.ata);
			}

			if (isInvalid) {
				subOrderIsInvalid = true;
				hasInvalidSubOrder = true;
			}
			errorsSubOrder.atd = isInvalid;
			errorsSubOrder.ata = isInvalid;
		}

		errorsSubOrder.isInvalid = subOrderIsInvalid;

		errorsSubOrders[subOrder.id] = errorsSubOrder;
	});

	errorsSubOrders.isInvalid = hasInvalidSubOrder;

	return errorsSubOrders;
}
